module.exports = __webpack_public_path__ + "static/mesmer_icon-07e7e9487ff7f8dc5c3be68e2d263055.png";